<div class="page-container reserve-add-content">
  <!-- 企業預約載入畫面 -->
  @if (isLoadingBusinessSuggestions && sharedStorageService.get('reserveType') === '2') {
    <div class="reserve-loading-container">
      <img
        width="28"
        height="28"
        ngSrc="assets/img/img-loadingAI.png"
        alt="Loading Image"
        class="loading-image"
      />
      <h2>載入加選中</h2>
      <div class="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  } @else {
    <!-- 原有的頁面內容 -->
    <div class="reserve-add-left-page" #reserveAddLeftPage>
      <!--tab區域-->
      <div class="reserve-add-tab-content">
        @if ((
          selectedPackage !==
            translateService.instant('reserve-result.all-checkup') &&
          selectedPackage !==
            translateService.instant('reserve-result.ai-exclusive') &&
          hasAbnormalData &&
          planType !== '0') &&
          sharedStorageService.get('reserveType') === '1'
        ) {
          <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 1"
            (click)="searchType = 1"
          >
            <img width="32" height="32" ngSrc="assets/img/i-track.svg" alt="" />
            {{ 'reserve-add.abnormal-tracking' | translate }}
          </button>
        } @else {
          @if (shouldShowAbnormalTrackingButton) {
            <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 1"
            (click)="searchType = 1"
          >
            <img width="32" height="32" ngSrc="assets/img/i-track.svg" alt="" />
            {{ 'reserve-add.abnormal-tracking' | translate }}
          </button>
          }
        }

        @if ((
          selectedPackage !==
          translateService.instant('reserve-result.all-checkup') &&
          planType !== '0') &&
          sharedStorageService.get('reserveType') === '1'
        ) {
          <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 2"
            (click)="searchType = 2"
          >
            <img width="32" height="32" ngSrc="assets/img/i-radar.svg" alt="" />
            {{ 'reserve-add.potential-disease' | translate }}
          </button>
        } @else {
          @if (sharedStorageService.get('reserveType') === '2' && (this.checkSuggestionsEnterpriseResponse?.potentialDetail ?? []).length > 0) {
            <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 2"
            (click)="searchType = 2"
          >
            <img width="32" height="32" ngSrc="assets/img/i-radar.svg" alt="" />
            {{ 'reserve-add.potential-disease' | translate }}
          </button>
          }
        }

        @if ((
          selectedPackage !==
            translateService.instant('reserve-result.basic-checkup') &&
          selectedPackage !==
            translateService.instant('reserve-result.all-checkup') &&
          selectedPackage !==
            translateService.instant('reserve-result.ai-exclusive')&&
          planType !== '0') &&
          sharedStorageService.get('reserveType') === '1'
        ) {
          <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 3"
            (click)="searchType = 3"
          >
            <img width="32" height="32" ngSrc="assets/img/i-advice.svg" alt="" />
            {{ 'reserve-add.body-insight' | translate }}
          </button>
        } @else {
          @if (sharedStorageService.get('reserveType') === '2' && (this.checkSuggestionsEnterpriseResponse?.basicCheckup ?? []).length > 0 && shouldShowBasicCheckupButton) {
            <button
            mat-button
            class="btn-card"
            [class.active]="searchType == 3"
            (click)="searchType = 3"
          >
            <img width="32" height="32" ngSrc="assets/img/i-advice.svg" alt="" />
            {{ 'reserve-add.body-insight' | translate }}
          </button>
          }
        }

        <button
          mat-button
          class="btn-card"
          [class.active]="searchType == 4"
          (click)="searchType = 4"
        >
          <img width="32" height="32" ngSrc="assets/img/i-search.svg" alt="" />
          {{ 'reserve-add.quick-search' | translate }}
        </button>
      </div>

      @if (searchType != 4 && searchType != 0) {
        <p class="reserve-add-card-title">{{ 'reserve-add.hint' | translate }}</p>
        <p class="hint-message"><img width="24" height="24" ngSrc="assets/img/info_circle.png" alt="" /> 
          {{ 'reserve-add.hint-message' | translate }}</p>
      } @else {
        <p class="reserve-add-card-title">
          {{ 'reserve-add.quick-search-hint' | translate }}
        </p>
        <p class="hint-message"><img width="24" height="24" ngSrc="assets/img/info_circle.png" alt="" /> 
          {{ 'reserve-add.hint-message' | translate }}</p>

        <!--tab:快速搜尋-->
        <div class="reserve-add-search-block">
          <div class="input-group input-btn-left">
            <input
              [placeholder]="'reserve-add.quick-search-placeholder' | translate"
              [(ngModel)]="quickSearchText"
              (ngModelChange)="quickSearchWithText()"
            />
            <button mat-icon-button type="button" class="input-search-btn">
              <img
                width="24"
                height="24"
                ngSrc="assets/img/i-search-b.svg"
                alt=""
              />
            </button>
          </div>
          
          <div class="reserve-add-search-block-btn">
            @for (deptName of quickSearchDeptNames; track i; let i = $index) {
              <button
                mat-button
                class="btn-outline-primary btn-tab btn-size-l"
                (click)="quickSearchWithDeptName(deptName)"
                [class.active]="deptName === quickSearchSelectedDeptName"
              >
                {{ deptName }}
              </button>
            }
          </div>
          <div class="input-block">
            <mat-form-field
              appearance="fill"
              class="reserve-add-search-block-select"
            >
              <mat-select [(value)]="selectedValue" placeholder="請選擇項目分類">
                @for (deptName of quickSearchDeptNames; track i; let i = $index) {
                  <mat-option 
                  [value]="deptName"
                  (click)="quickSearchWithDeptName(deptName)"
                  [class.active]="deptName === quickSearchSelectedDeptName"
                >
                {{ deptName }}
              </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      <!--方案卡片區域-->
      <div class="reserve-add-card-block">
        @for (examInfo of sortedExamInfoList; track examInfo.examItem) {
          <!-- 若是企業預約且方案內檢項，則不顯示(包含互斥檢項) -->
          @if (!(sharedStorageService.get('reserveType') === '2' && isExamInPackage(examInfo.examItem)) && 
               !(sharedStorageService.get('reserveType') === '2' && mutexInfos.has(examInfo.examItem) && 
                 isOriginalPackageMutex(examInfo.examItem)) &&
               !(sharedStorageService.get('reserveType') === '2' && hasMutexWithPackageItems(examInfo.examItem)) &&
               !(sharedStorageService.get('reserveType') === '2' && isFromMemberCenter && mutexInfos.has(examInfo.examItem) && 
                 isAddedExamMutex(examInfo.examItem))) {
            <div
              class="reserve-plan-card"
              [ngClass]="{
                active:
                  checkedExamItemSet.has(examInfo.examItem) ||
                  checkedExamItemListUnderPackage.includes(examInfo.examItem),
                disabled: mutexInfos.has(examInfo.examItem),
                'active-disabled': isActiveDisabled(
                  examInfo.examItem,
                  examInfo.examType
                ),
              }"
              (click)="
                !mutexInfos.has(examInfo.examItem) &&
                  toggleChecked(
                    !checkedExamItemSet.has(examInfo.examItem) &&
                      !checkedExamItemListUnderPackage.includes(examInfo.examItem),
                    examInfo
                  )
              "
            >
              <div class="reserve-plan-title">
                <span class="reserve-plan-subtitle">{{ examInfo.deptName }}</span>
                <h2>{{ examInfo.examName }}</h2>
                <p class="reserve-plan-memo">{{ examInfo.examMemo }}</p>
              </div>

              <div class="reserve-price-block">
                <p class="reserve-plan-price">
                  @if (!isExamInPackage(examInfo.examItem)) {
                    <label>$</label>
                    {{ examInfo.price | numberComma }}
                  }@else if (isExamInPackage(examInfo.examItem)) {
                    <span class="package-price-text">方案價</span>
                  }
                </p>
                  @if (sharedStorageService.get('reserveType') === '1') {
                    <!-- 個人預約：非必要檢項或方案內非標準檢項都顯示 checkbox -->
                    @if (!examInfo.isNecessary || (examInfo.isNecessary && !examInfo.isChoice && !isFromMemberCenter)) {
                      <mat-checkbox
                        [disabled]="mutexInfos.has(examInfo.examItem)"
                        (change)="toggleChecked($event.checked, examInfo)"
                        [checked]="
                          checkedExamItemSet.has(examInfo.examItem) ||
                          checkedExamItemListUnderPackage.includes(examInfo.examItem)
                        "
                        (click)="$event.stopPropagation()"
                        [ngClass]="{
                          'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                        }"
                      >
                      </mat-checkbox>
                    }
                  } @else if (sharedStorageService.get('reserveType') === '2') {
                    <!-- 企業預約：只有非必要檢項顯示 checkbox -->
                    @if (!isExamInPackage(examInfo.examItem) && !isFromMemberCenter) {
                      <mat-checkbox
                        [disabled]="mutexInfos.has(examInfo.examItem)"
                        (change)="toggleChecked($event.checked, examInfo)"
                        [checked]="
                          checkedExamItemSet.has(examInfo.examItem) ||
                          checkedExamItemListUnderPackage.includes(examInfo.examItem)
                        "
                        (click)="$event.stopPropagation()"
                        [ngClass]="{
                          'mat-checkbox-disabled': mutexInfos.has(examInfo.examItem),
                        }"
                      >
                      </mat-checkbox>
                    }
                  }
              </div>
            </div>
          }
        }
      </div>
    </div>

  <!--購物車(方案檢項)-->
  <div class="reserve-add-right-cart" #reserveAddRightCart>
    <!-- 關閉按鈕-->
    <div class="reserve-add-right-cart-header">
      <button mat-button class="btn-icon-close" (click)="toggleCart()">
        <img width="32" height="32" ngSrc="assets/img/i-close.svg" alt="" />
      </button>
    </div>

    <!-- 已選方案-->
    <div class="reserve-add-right-cart-body">
      <div
        class="reserve-add-right-cart-title"
        (click)="isPackageOpen = !isPackageOpen"
      >
        <h2>
          {{ 'reserve-add.selected-package' | translate }} {{ selectedPackage }}
        </h2>
        <button mat-button class="btn-icon">
          <img
            width="24"
            height="24"
            alt=""
            [ngSrc]="
              isPackageOpen
                ? 'assets/img/i-arrow-up.svg'
                : 'assets/img/i-arrow-down.svg'
            "
          />
        </button>
      </div>

      @if (isPackageOpen) {
        @if (
          this.sharedStorageService.get('reserveType') ===
          ID_LOGIN_TYPE.PERSONAL
        ) {
          <!--個人預約-->
          @for (
            examTypeMap of examInfoListUnderPackageByType.entries();
            track examTypeMap[0]
          ) {
            <div class="reserve-add-right-cart-item">
              @if(examTypeMap[0] !== 'unknown'){
                <h3>{{ examTypeMap[0] }}</h3>
              }
              
              @for (deptMap of examTypeMap[1]; track deptMap[0]) {
                <div
                  class="reserve-add-right-cart-item-title"
                  (click)="toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])"
                >
                  <h4>{{ deptMap[0] }}</h4>
                  <button mat-button class="btn-icon">
                    <img
                      width="24"
                      height="24"
                      alt=""
                      [ngSrc]="
                        getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                          ? 'assets/img/i-arrow-up.svg'
                          : 'assets/img/i-arrow-down.svg'
                      "
                    />
                  </button>
                </div>
                @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
                  <div class="reserve-add-right-cart-item-block">
                    @for (examInfo of deptMap[1]; track examInfo.examItem) {
                      <div class="reserve-add-right-cart-checked-item" 
                        [ngClass]="{'disabled': mutexInfos.has(examInfo.examItem)}">
                        <div>
                          <button
                            mat-icon-button
                            type="button"
                            class="btn-icon btn-info"
                            (click)="showExamDialog(examInfo)"
                          >
                            <img
                              width="14"
                              height="14"
                              ngSrc="assets/img/i-info.svg"
                              alt=""
                            />
                          </button>
                          <p>{{ examInfo.examName }}</p>
                        </div>
                        <!-- 不是必檢項目才可以有勾選/取消功能 -->
                        @if (
                          examInfo.examType !==
                            examTypeText[0] && !isPersonal
                        ) {
                          <mat-checkbox
                            [disabled]="mutexInfos.has(examInfo.examItem)"
                            [checked]="
                              checkedExamItemListUnderPackage.includes(
                                examInfo.examItem
                              )
                            "
                            (change)="
                              toggleCheckedUnderPackage(
                                $event.checked,
                                examInfo
                              )
                            "
                          >
                          </mat-checkbox>
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        } @else {
          <!--企業預約-->
          @for (
            examTypeMap of examInfoListUnderPackageByType.entries();
            track examTypeMap[0]
          ) {
            <div class="reserve-add-right-cart-item">
              @if(examTypeMap[0] !== 'unknown'){
                <h3>{{ examTypeMap[0] }}</h3>
              }
              
              @for (deptMap of examTypeMap[1]; track deptMap[0]) {
                <div
                  class="reserve-add-right-cart-item-title"
                  (click)="toggleDeptOpenStateByExamType(examTypeMap[0], deptMap[0])"
                >
                  <h4>{{ deptMap[0] }}</h4>
                  <button mat-button class="btn-icon">
                    <img
                      width="24"
                      height="24"
                      alt=""
                      [ngSrc]="
                        getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])
                          ? 'assets/img/i-arrow-up.svg'
                          : 'assets/img/i-arrow-down.svg'
                      "
                    />
                  </button>
                </div>
                @if (getDeptOpenStateByExamType(examTypeMap[0], deptMap[0])) {
                  <div class="reserve-add-right-cart-item-block">
                    @for (examInfo of deptMap[1]; track examInfo.examItem) {
                      <div class="reserve-add-right-cart-checked-item" 
                        [ngClass]="{'disabled': mutexInfos.has(examInfo.examItem)}">
                        <div>
                          <button
                            mat-icon-button
                            type="button"
                            class="btn-icon btn-info"
                            (click)="showExamDialog(examInfo)"
                          >
                            <img
                              width="14"
                              height="14"
                              ngSrc="assets/img/i-info.svg"
                              alt=""
                            />
                          </button>
                          <p>{{ examInfo.examName }}</p>
                        </div>
                        <!-- 企業預約的檢項控制 -->
                        @if (
                          examInfo.examType !==
                            examTypeText[0]
                        ) {
                          <mat-checkbox
                            [disabled]="mutexInfos.has(examInfo.examItem)"
                            [checked]="
                              checkedExamItemListUnderPackage.includes(
                                examInfo.examItem
                              )
                            "
                            (change)="
                              toggleCheckedUnderPackage(
                                $event.checked,
                                examInfo
                              )
                            "
                          >
                          </mat-checkbox>
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
        }
      }

      <!--購物車(加選檢項)-->
      <div class="reserve-add-right-cart-title add-title">
        <h2>{{ 'reserve-add.add-exam-item' | translate }}</h2>
        <div (click)="isAddPackageOpen = !isAddPackageOpen">
          <span>{{ checkedExamInfoList.length }}</span>
          <button mat-button class="btn-icon">
            <img
              width="24"
              height="24"
              alt=""
              [ngSrc]="
                isAddPackageOpen
                  ? 'assets/img/i-arrow-up.svg'
                  : 'assets/img/i-arrow-down.svg'
              "
            />
          </button>
        </div>
      </div>
      @if (isAddPackageOpen) {
        <div class="reserve-add-right-cart-item-block add-item">
          @if (checkedExamInfoList.length > 0) {
            @for (
              addExamInfo of checkedExamInfoList;
              track addExamInfo.examItem
            ) {
              <div class="reserve-add-right-cart-checked-item">
                <div>
                  <button
                    mat-icon-button
                    type="button"
                    class="btn-icon btn-info"
                    (click)="showExamDialog(addExamInfo)"
                  >
                    <img
                      width="14"
                      height="14"
                      ngSrc="assets/img/i-info.svg"
                      alt=""
                    />
                  </button>
                  <p>{{ addExamInfo.examName }}</p>
                </div>
                <div>
                  <p class="reserve-add-item-checked-item">
                    <label>$</label> {{ addExamInfo.price | numberComma }}
                  </p>
                  <mat-checkbox
                    (change)="toggleChecked($event.checked, addExamInfo)"
                    [checked]="checkedExamInfoList.includes(addExamInfo)"
                  >
                  </mat-checkbox>
                </div>
              </div>
            }
          } @else {
            <div class="empty-cart">
              <img
                width="89"
                height="78"
                ngSrc="assets/img/img-empty.svg"
                alt=""
              />
              <p>{{ 'reserve-add.empty-items' | translate }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!--頁面：固定按鈕區塊-->
  <div class="page-btn-block">
    <div class="btn-group">
      @if (!isPersonal) {
        <button
        mat-button
        (click)="resetPackage()"
        class="btn-outline-primary btn-size-l"
      >
        {{ 'reserve-add.reset-package' | translate }}
      </button>
      }
      
      <button
        mat-button
        (click)="handleNextClick()"
        class="btn-fill-primary btn-size-l"
      >
        {{ 'common.button.next' | translate }}
      </button>
    </div>
    <div class="page-pay">
      <!-- 企業預約且金額小於0時顯示補助尚餘 -->
      @if (paymentAmount < 0 && sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE) {
        <span>{{ 'reserve-add.subsidy-amount' | translate }}</span>
      } @else {
        <span>{{ 'reserve-add.payment-amount' | translate }}</span>
      }
      <label>$</label>
      @if (paymentAmount < 0 && sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE) {
        {{ Math.abs(paymentAmount) | numberComma }}
      } @else {
        {{ paymentAmount | numberComma }}
      }
    </div>
  </div>

  <!--右下角：固定按鈕-->
  <div class="page-btn-fixed">
    <button mat-button class="side-shop-btn" (click)="toggleCart()">
      <img
        width="60"
        height="60"
        ngSrc="assets/img/img-sidebar-shop.png"
        alt=""
      />
      @if (checkedExamInfoList.length > 0) {
        <div>
          <span>{{ checkedExamInfoList.length }}</span>
        </div>
      }
    </button>
  </div>
  }
</div>
